import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../store/reducers";
import {deletePenaltyForm} from "../store/actions/penaltyForm";
import {Alert, Button, Spinner} from "reactstrap";


type PenaltyDeleteType = {
    deletePenaltyForm: (id: number) => void
    cancelHandler?: () => void
    id: number
    changeLoading: boolean
    changeError: string
}

class PenaltyDeleteContainer extends Component<PenaltyDeleteType> {

    render() {
        const {id, changeLoading, changeError, cancelHandler, deletePenaltyForm} = this.props;

        return (
            <>
                {changeError &&
                (<Alert className={'mt-3'} color={'danger'}>
                    {changeError}
                </Alert>)}
                <div className={'text-right'}>
                    {cancelHandler &&
                    <Button onClick={cancelHandler} color={'primary'} className={'mr-3'}>Не удалять</Button>}
                    <Button onClick={() => deletePenaltyForm(id)} color={'danger'} disabled={changeLoading}>
                        {changeLoading &&
                        (<Spinner

                            size="sm"
                        />)}
                        Да, удалить
                    </Button>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: AppState) => {
    const {changeLoading, changeError} = state.penaltyForm;

    return {
        changeLoading,
        changeError
    }
};

const mapDispatchToProps = {
    deletePenaltyForm
};


export default connect(mapStateToProps, mapDispatchToProps)(PenaltyDeleteContainer);
